import { MixpanelClient } from './mixpanelClient';
import { NoopAnalyticsClient } from './noopClient';
import { AnalyticsClient } from '../types/client';

const analyticsClient: AnalyticsClient =
    process.env.NODE_ENV === 'production' ? new MixpanelClient() : new NoopAnalyticsClient();

export { analyticsClient };
